import { render, staticRenderFns } from "./PJProposalOtherInformation.vue?vue&type=template&id=b5a802b4"
import script from "./PJProposalOtherInformation.vue?vue&type=script&lang=js"
export * from "./PJProposalOtherInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports